// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Global utilities for admin pages
import "./salesforce_field_import"

import LocalTime from "local-time"
LocalTime.start()

import "trix"
import "@rails/actiontext"
